import React from 'react';
import cn from 'classnames';

import { ISection } from '../constants';
import img1 from '../../../images/AdvantagesConvenience.png';
import Tag from '../../UIkit/Tag';
import NavigationArrow from '../../SVG/NavigationArrow';
import { useResize } from '../../../utils/hooks';

import style from './Monitoring.module.css';
import { IProduct, MonitoringDPConstant } from './1MonitoringConstants';

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> {
  id: number;
  // className: string;
  name: string;
  item: IProduct;
}
function MonitoringDP({ item, name, id, ...props }: Props): JSX.Element {
  const { isScreen900 } = useResize();
  return (
    <div id="#sectionDP" className={style.sectionDP}>
      <div
        className={style.detailitem__title}
        style={{
          flexDirection: isScreen900 ? (id % 2 == 0 ? 'row-reverse' : 'row') : 'column-reverse',
          gap: isScreen900 ? '0' : '10px',
          alignItems: isScreen900 ? 'space-between' : 'start',
        }}
      >
        <Tag title="Продукты INNERICA" color="grey" className={style.maintag} />
        <h2>{item.name}</h2>
      </div>
      <div className={cn(style.grid, props.className, style.grid1)}>
        <div className={style.card}>
          <p>{item.text}</p>
          <NavigationArrow className={style.arrow} color="#688AEA" />
        </div>
        <div className={style.card}>
          <ul className={style.list}>
            {item.list.map(el => {
              return <li key={`ItemDP_itemlist__${el}`}>{el}</li>;
            })}
          </ul>
          <NavigationArrow className={style.arrow} color="#688AEA" />
        </div>
        <div className={cn(style.card, style.active)}>
          <Tag className={style.card__tag} title={'Эффекты'} color="second" type="filled" />
          <ul className={style.list}>
            {item.effects.map(el => {
              return <li key={`ItemDP_effects__${el}`}>{el}</li>;
            })}
          </ul>
        </div>
        {item.items.map((el, index) => {
          return (
            <div className={style.boxitem} key={`ItemDP_${el.Id}`}>
              {/* <Tag className={style.boxitem__Id} title={el.Id} color="grey" /> */}
              <div className={style.boxitem__Id}>/ {el.Id}</div>
              <div className={style.boxitem__Title}>{el.Title}</div>
              <div className={style.boxitem__Text}>{el.Text}</div>
            </div>
            //   {index == 4 &&
            //     <div className={style.class2}>
            //       {item.img && <img src={item.img} alt={item.name} />}
            //     </div>}
            // </>
          );
        })}
        <div className={style.class1}>{item.img && <img src={item.img} alt={item.name} />}</div>
        {/* <div className={style.btnbox}>
          <Button className={style.btn} onClick={contactUs.open} variant="filled" round>
            Заказать бесплатную демонстрацию
          </Button>
        </div> */}
      </div>
    </div>
  );
}

export default MonitoringDP;
